import { Document } from '../../../../../../interfaces/Document';

export default function getDocumentsInSameGroup(document: Document, documents: Document[]): Document[] {
  return documents.filter((doc) => document.grouped && doc.grouped
    && document.contract.contractNumber === doc.contract.contractNumber
    && document.contract.systemCode === doc.contract.systemCode
    && document.type.id === doc.type.id
    && document.id !== doc.id);
}
